import React, { useState, useEffect, useRef } from "react";
import { SketchPicker } from "react-color";

function ColorPickerInput({
  placeholder,
  name,
  value,
  onChange,
  error,
  disabled,
  setColorFromParent,
}) {
  const [color, setColor] = useState(value || "#000000");
  const [visible, setVisible] = useState(false);
  const pickerRef = useRef(null);

  useEffect(() => {
    setColor(value);
  }, [value]);

  useEffect(() => {
    if (setColorFromParent) {
      setColorFromParent(setColor);
    }
  }, [setColorFromParent]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pickerRef]);

  const handleClick = () => {
    setVisible(!visible);
  };

  const handleChange = (color) => {
    setColor(color.hex);
    onChange(color.hex);
  };

  return (
    <div id="color-picker-input-wrapper" style={{ position: "relative" }}>
      <div
        onClick={handleClick}
        className="ant-input d-flex flex-row"
        style={{ cursor: "pointer" }}
      >
        <div
          style={{
            backgroundColor: color,
            width: "16px",
            height: "16px",
            margin: "3px",
            borderRadius: 2,
            border: "1px solid #D9D9D9",
          }}
        />
        <span style={{ marginLeft: "2px" }}>{color || "#000000"}</span>
      </div>
      {visible && (
        <div
          ref={pickerRef}
          style={{
            position: "absolute",
            zIndex: 1000,
            top: "100%",
            left: 0,
          }}
        >
          <SketchPicker color={color} onChange={handleChange} />
        </div>
      )}
    </div>
  );
}

export default ColorPickerInput;
